/**
 * @generated SignedSource<<c7ebff93be53d131dffb5db3517b56eb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type templateEditorDialogQuery$variables = {
  categoryId?: number | null;
  designId?: number | null;
  modelID: string;
};
export type templateEditorDialogQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"templateEditorDialog_fragment">;
};
export type templateEditorDialogQuery = {
  response: templateEditorDialogQuery$data;
  variables: templateEditorDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "designId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelID"
},
v3 = {
  "kind": "Variable",
  "name": "categoryId",
  "variableName": "categoryId"
},
v4 = {
  "kind": "Variable",
  "name": "designId",
  "variableName": "designId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateEditorDialogQuery",
    "selections": [
      {
        "args": [
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "kind": "Variable",
            "name": "modelID",
            "variableName": "modelID"
          }
        ],
        "kind": "FragmentSpread",
        "name": "templateEditorDialog_fragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "templateEditorDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "modelID"
          }
        ],
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "concreteType": "TemplateEditorIframe",
            "kind": "LinkedField",
            "name": "iframeDesignUrl",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "largeUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mobileUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "434e7fe2955d23ff4a4ace177f62f8fd",
    "id": null,
    "metadata": {},
    "name": "templateEditorDialogQuery",
    "operationKind": "query",
    "text": "query templateEditorDialogQuery(\n  $modelID: ID!\n  $designId: Long\n  $categoryId: Long\n) {\n  ...templateEditorDialog_fragment_1YZhoM\n}\n\nfragment templateEditorDialog_fragment_1YZhoM on Query {\n  model(id: $modelID) {\n    id\n    name\n    code\n    iframeDesignUrl(designId: $designId, categoryId: $categoryId) {\n      largeUrl\n      mobileUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b10edbdb3178f3f71c9d866d4f50635";

export default node;
